import { ContentPaste, Description } from "@mui/icons-material";
import { Button, IconButton, TableCell, Tooltip } from "@mui/material";
import { useSessionContext } from "../../../../../contexts/SessionContext";
import { useEhrRecordsMobileLayout } from "../../../context/EhrRecordsLayoutContext";
import {
  EhrMobileActionStack,
  ehrMobileActionBtnSx,
} from "../../mobile/EhrMobileActionStack";

interface IProps {
  row: any;
  handleOpen: any;
  setResponseData: any;
  openVisualizer: any;
  verifyVisualizer: any;
}

function isEmptyObject(obj: any): boolean {
  return obj && typeof obj === "object" && Object.keys(obj).length === 0;
}

export function ObservationEncounterActions({
  row,
  handleOpen,
  setResponseData,
  openVisualizer,
  verifyVisualizer,
}: IProps) {
  const { access } = useSessionContext();
  const isEhrMobileCard = useEhrRecordsMobileLayout();
  const hasObs = !isEmptyObject(row?.obs);
  const canViewEncounter =
    verifyVisualizer &&
    verifyVisualizer(row?.encounterId) &&
    access?.type === "professional";

  if (isEhrMobileCard) {
    if (!hasObs && !canViewEncounter) return null;

    return (
      <EhrMobileActionStack>
        {hasObs ? (
          <Button
            fullWidth
            variant="contained"
            color="primary"
            startIcon={<Description />}
            sx={ehrMobileActionBtnSx}
            onClick={() => {
              handleOpen();
              setResponseData(row?.obs);
            }}
          >
            Acessar observações
          </Button>
        ) : null}

        {canViewEncounter ? (
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            startIcon={<ContentPaste />}
            sx={ehrMobileActionBtnSx}
            onClick={() => {
              openVisualizer(row?.encounterId);
            }}
          >
            Visualizar atendimento
          </Button>
        ) : null}
      </EhrMobileActionStack>
    );
  }

  return (
    <TableCell align="center">
      {hasObs ? (
        <Tooltip title="Acessar">
          <IconButton
            onClick={() => {
              handleOpen();
              setResponseData(row?.obs);
            }}
          >
            <Description />
          </IconButton>
        </Tooltip>
      ) : null}

      {canViewEncounter ? (
        <Tooltip title="Visualizar atendimento">
          <IconButton
            onClick={() => {
              openVisualizer(row?.encounterId);
            }}
          >
            <ContentPaste />
          </IconButton>
        </Tooltip>
      ) : null}
    </TableCell>
  );
}
